// NewWallofFame.jsx

import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./NewWallofFame.css";

import {
  FaFacebookF,
  FaInstagram,
  FaThreads,
} from "react-icons/fa6";

import HomeService from "../../../Services/HomeService";

const NewWallofFame = () => {

  const [wallOfFame, setWallOfFame] = useState([]);

  const fetchWallOfFame = async () => {
    try {

      const res = await HomeService?.getWallOfFame();

      if (res?.status) {
        setWallOfFame(res?.data);
      }

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchWallOfFame();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 2600,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,

    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="elitefame-main-section">
        <div className="moderntesti-blur-one"></div>

      <div className="moderntesti-blur-two"></div>

      <div className="elitefame-container">

        <div className="elitefame-top-wrapper">

          <span className="elitefame-subtitle">
            Wall Of Fame
          </span>

          <h2 className="elitefame-title">
            The Faces Behind
            Exceptional Success
          </h2>

        </div>

        <div className="elitefame-slider-wrapper">

          <Slider {...settings}>

            {wallOfFame?.map((e, i) => (

              <div className="elitefame-slide-item" key={i}>

                <div className="elitefame-card">

                  {/* LEFT IMAGE */}

                  <div className="elitefame-image-side">

                    <img
                      src={e?.image}
                      alt=""
                    />

                    <div className="elitefame-socials">

                      <span>
                        <FaFacebookF />
                      </span>

                      <span>
                        <FaInstagram />
                      </span>

                      <span>
                        <FaThreads />
                      </span>

                    </div>

                  </div>

                  {/* RIGHT CONTENT */}

                  <div className="elitefame-content-side">

                    <div className="elitefame-quote">
                      “
                    </div>

                    <h3>
                      {e?.name}
                    </h3>

                    <span>
                      {e?.designation}
                    </span>

                    {/* <p>
                      Recognized for delivering
                      exceptional performance,
                      trusted relationships, and
                      outstanding contributions
                      in the real estate industry.
                    </p> */}

                    <div className="elitefame-line"></div>

                    <div className="elitefame-bottom">

                      <small>
                        Excellence Award
                      </small>

                      <button>
                        View Profile
                      </button>

                    </div>

                  </div>

                </div>

              </div>

            ))}

          </Slider>

        </div>

      </div>

    </section>
  );
};

export default NewWallofFame;